import styled from 'styled-components';

/* ── variante: telas de login ── */
export const LoginWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  margin-top: 8px;
`;

export const LoginDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-muted);
  font-size: 13px;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--line);
  }
`;

export const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 54px;
  padding: 14px 20px;
  border-radius: 12px;
  border: 2px solid var(--coral);
  background: transparent;
  color: var(--coral);
  font-family: inherit;
  font-size: 17px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.12s ease;

  &:hover, &:focus-visible {
    background: var(--coral);
    color: #fff;
    transform: translateY(-1px);
  }
  &:active { transform: translateY(0); }
`;

export const LoginHint = styled.p`
  margin: 0;
  text-align: center;
  font-size: 13px;
  color: var(--text-muted);
`;

/* ── variante: menu hambúrguer ── */
export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 360px;
  flex-shrink: 0;
  box-sizing: border-box;
  min-height: 52px;
  margin-top: 8px;
  padding: 14px 18px;
  border-radius: 12px;
  border: 1px solid rgba(224, 122, 95, 0.6);
  background: rgba(224, 122, 95, 0.22);
  color: #ffffff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  &:hover, &:active { background: rgba(224, 122, 95, 0.35); }
`;

/* ── modal de instruções (iPhone/iPad) ── */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const Modal = styled.div`
  position: relative;
  width: 100%;
  max-width: 380px;
  background: var(--surface, #fff);
  color: var(--text, #16323b);
  border-radius: 16px;
  padding: 24px 22px 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);

  h3 { margin: 0 0 14px; font-size: 18px; }
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  padding: 6px;
`;

export const Steps = styled.ol`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 15px;
  line-height: 1.4;

  svg { vertical-align: middle; margin-left: 2px; }
`;
